import type { SVGProps } from 'react';

export const ChevronBackward = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m11.05 12 4.075-4.075a.774.774 0 0 0 .225-.5c0-.217-.075-.4-.225-.55a.72.72 0 0 0-.525-.225.72.72 0 0 0-.525.225l-4.5 4.5a.681.681 0 0 0-.175.3.716.716 0 0 0-.075.325c0 .117.025.233.075.35a.7.7 0 0 0 .175.275l4.5 4.5a.802.802 0 0 0 .525.225.72.72 0 0 0 .525-.225.72.72 0 0 0 .225-.525.72.72 0 0 0-.225-.525L11.05 12Z" />
    </svg>
  );
};
